import { FavoriteReference, ID } from '@griply/types';

// Reorders `favorites` so the refs whose id appears in `orderedIds` follow that
// order, while refs absent from `orderedIds` (e.g. hidden task favorites) stay
// at their original positions. With every id supplied this is a full reorder;
// with a subset it is a stable merge that never drops the untouched refs.
export const reorderFavorites = (
  favorites: FavoriteReference[],
  orderedIds: ID[],
): FavoriteReference[] => {
  const orderedSet = new Set(orderedIds);
  const byId = new Map(favorites.map((favorite) => [favorite.id, favorite]));

  const reordered = orderedIds.reduce<FavoriteReference[]>((acc, id) => {
    const favorite = byId.get(id);
    if (favorite) {
      acc.push(favorite);
    }
    return acc;
  }, []);

  let cursor = 0;
  return favorites.map((favorite) =>
    orderedSet.has(favorite.id) ? reordered[cursor++] ?? favorite : favorite,
  );
};
